export enum EVENT_BUS_EVENT {
  SCROLL_FILTER_TO_TOP = 'scroll-filter-to-top',
  OPEN_ACCORDION = 'open-accordion',
  OPEN_DATE_PICKER = 'open-date-picker',
  CLEAR_CUSTOM_FIELDS_PORTALS = 'clear-custom-fields-portals',
  REFETCH_QRC = 'refetch-qrc',
  LOGOUT = 'logout'
}